import { put, select } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { writeToLocalStorage } from "common/utilities/localStorage";
import { trackSaga } from "common/utilities/trackSaga";
import { fetchTermsFailure, fetchTermsSuccess } from "domains/language/actions";
import type { FetchLanguageTermsDefaultAction } from "domains/language/actionTypes";
import { getSiteLanguage, getSiteLanguageLabel } from "domains/language/selectors";
import type { PayloadTerm } from "domains/language/types";

export function* fetchTermsSaga(action: FetchLanguageTermsDefaultAction) {
  try {
    const { language } = action.meta;

    if (!action.meta.initialising) {
      const siteLanguage: ReturnType<typeof getSiteLanguage> = yield select(getSiteLanguage);
      const siteLanguageLabel: ReturnType<typeof getSiteLanguageLabel> = yield select(getSiteLanguageLabel);

      yield trackSaga({
        entityId: siteLanguage,
        entityName: siteLanguageLabel,
        entityType: "Language",
        name: "Change Language",
      });
    }

    const terms: PayloadTerm[] = yield apiFetch(`language/${language}/term`);

    yield put(fetchTermsSuccess({ terms }, action.meta));

    document.documentElement.lang = language;

    writeToLocalStorage("language", language);
    writeToLocalStorage("terms", terms);
  } catch {
    yield put(fetchTermsFailure());
  }
}
